import { KibsiClient } from './base';
export class TagKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, 'search-tags');
    }
    listTags(paginationRequest, requestConfig) {
        const { continuationToken, pageSize } = paginationRequest || {};
        const request = requestConfig ? { ...requestConfig } : {};
        request.params = {
            ...requestConfig?.params,
            continuationToken,
            pageSize,
        };
        return this.get('/tags', request);
    }
    createTag(tag, requestConfig) {
        return this.post('/tags', tag, requestConfig);
    }
    getTag(tagId, requestConfig) {
        return this.get(`tags/${tagId}`, requestConfig);
    }
    deleteTag(tagId, requestConfig) {
        return this.del(`tags/${tagId}`, requestConfig);
    }
    /**
     *
     * @param tagIds - if supplied will limit resources to those that match 1 or more of supplied tagIds
     * @param resourceIds - will filter resources to only return resources that match resourceIds.
     * @param resourceType - will filter return resources by resourceType
     * @param requestConfig - axios request config
     * @returns - TaggedResources that match the supplied criteria
     */
    listResources(tagIds, resourceIds, resourceType, requestConfig) {
        const strTagIds = tagIds.length > 0 ? tagIds.join(',') : undefined;
        const strResourceIds = resourceIds.length > 0 ? resourceIds.join(',') : undefined;
        return this.get(`/resources`, {
            params: { tagId: strTagIds, resourceId: strResourceIds, resourceType },
            ...requestConfig,
        });
    }
    deleteResource(resourceId, requestConfig) {
        return this.del(`/resources/${resourceId}`, requestConfig);
    }
    tagResource(resource, requestConfig) {
        const { resourceId } = resource;
        return this.put(`resources/${resourceId}/tags`, resource, requestConfig);
    }
    removeTagFromResource(tagId, resourceId, requestConfig) {
        return this.del(`resources/${resourceId}/tags/${tagId}`, requestConfig);
    }
}
//# sourceMappingURL=tag.js.map